var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42058 0H0V31.7355H3.42058V0Z",
    fill: "#EA5554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0007 2.88281H42.5801V31.7357H46.0007V2.88281Z",
    fill: "#EA5554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5729 21.25H22.1523V39.9872H25.5729V21.25Z",
    fill: "#EA5554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7318 28.4297H1.71094V31.7355H18.7318V28.4297Z",
    fill: "#EA5554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5729 28.4297H22.1523V31.7355H25.5729V28.4297Z",
    fill: "#EA5554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9993 28.4297H28.9785V31.7355H45.9993V28.4297Z",
    fill: "#EA5554"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0006 2.88281V6.1886H18.6497L15.6669 3.30595H3.42123V6.1886H1.71094V2.88281H46.0006Z",
    fill: "#EA5554"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6883 3.30579H1.71094V0H17.2677L20.2642 2.88264L20.3052 2.93554L20.6883 3.30579Z",
    fill: "#EA5554"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.685 6.18843H18.6498L15.6671 3.30579L14.2578 1.95702L16.2828 0H17.2679L20.2644 2.88264L20.3054 2.93554L20.6885 3.30579L23.685 6.18843Z",
    fill: "#EA5554"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.684 15.8682L27.7613 19.7558L31.8523 23.6301H23.684H15.502L19.593 19.7558L23.684 15.8682Z",
    fill: "#EA5554"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.4583e1933d74b32079b4439f5462e0b9.svg";
export { ForwardRef as ReactComponent };